<template>
    <div 
        v-if="userRole && (userRole.indexOf('ADMIN') > -1 || userRole.indexOf('PECHNIK') > -1)"
        class="gz-auth-menu" 
        @click="$router.push('/admin/staff/' + userId + '/info').catch(()=>{})"
    >
        <div class="gz-auth-menu__avatar">
            <span class="icon-user"></span>
        </div>
        <div class="gz-auth-menu__info" v-if="userViewComputed.attributes">
            <div>
                <span>{{ userViewComputed.attributes.lname }} {{ userViewComputed.attributes.fname }} {{ userViewComputed.attributes.pname || '' }}</span>
            </div>
            <div>
                <span>{{ userViewComputed.attributes ? userViewComputed.attributes.email : '' }}</span>
            </div>
            <div class="gz-auth-menu__role">
                <span>{{ roleName }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'AuthMenu',

    data() {
        return {
            userView: {},
            roleName: ''
        }
    },
    computed: {
        ...mapGetters({
            userRole: 'authRole',
            userId: 'authUserId',
            roles: 'filtersRoles'
        }),
        userViewComputed() {
            return this.userView
        }
    },
    mounted() {
        if (this.userId) {
            this.$store.dispatch('staffUserviewGet', this.userId)
                .then(() => {
                    this.userView = this.$store.getters['staffUserview']
                    this.roleSetup()
                })
        }
    },
    methods: {
        roleSetup() {
            this.roles.forEach(item => {                
                if (this.userViewComputed.attributes.role.includes(item.value)) {
                    this.roleName = item.name.toLowerCase()
                }
            })
        }
    }
}
</script>